import Profile from './profile';

export default {
  component: Profile,
  url: '/profile',
  exact: false,
};
